<script lang="js">
  import Toastify from "toastify-js";
  import ToastContent from "../components/ToastContent.svelte";
  import { FABCookie } from "../../fab/helper/index";

  let { to_display, nonce, rest_url } = window.FAB_PLUGIN;

  // Create a new Toast instance and append it into DOM (inline-block).
  const createToastNode = (props) => {
    const element = document.createElement("div");
    element.style.display = "inline-block";

    new ToastContent({
      target: element,
      props,
    });
    return element;
  };

  // Handle mouseover event on each Toasts and pause it when mouseleave occurs, then resume after a delay (duration).
  const handleToastPauseResume = (toastElement, toastBar, duration) => {
    let startTime = Date.now();
    let remainingTime = duration;
    let isPaused = false;

    // Pause the timeout when mouseover
    toastElement.addEventListener("mouseover", function () {
      if (!isPaused) {
        isPaused = true;
        remainingTime -= Date.now() - startTime; // Calculate remaining time
        window.clearTimeout(toastElement.timeOutValue); // Clear the timeout

        // Pause the animation
        toastBar.style.animationPlayState = "paused";
      }
    });

    // Resume the timeout when mouseleave
    toastElement.addEventListener("mouseleave", function () {
      if (isPaused) {
        isPaused = false;
        // Start the timeout again with the remaining time
        startTime = Date.now();

        toastElement.timeOutValue = window.setTimeout(function () {
          toastElement.remove(); // Remove toast after remaining time
        }, remainingTime);

        // Resume the animation
        toastBar.style.animationPlayState = "running";
      }
    });
  };

  // Handle click event on each Toasts.
  const handleToastOnClick = (toastElement, data) => {
    const toastEventListenerOnClick = (event) => {
      event.stopImmediatePropagation();

      let cookieKey = `FABToast-${data.ID}`;
      let cookie = FABCookie.getCookie(cookieKey);
      let rememberOnClick = data.toast.remember_on_click;
      let expiration = parseInt(data.trigger.cookie.expiration);

      if (!cookie && rememberOnClick && data.toast.url_button && data.toast.text_button) {
        FABCookie.setCookie(cookieKey, expiration, 9999, "/");
      }

      if (data.toast.url_button && data.toast.text_button) {
        jQuery.ajax({
          url: rest_url + "fab/v1/clicked",
          type: "POST",
          beforeSend: function (xhr) {
            xhr.setRequestHeader("X-WP-Nonce", nonce.clicked);
          },
          data: {
            post_id: data.ID,
          },
          success: (response) => {
            if (data.toast.window === 1) {
              window.open(data.toast.url_button, "_blank");
            } else {
              window.location = data.toast.url_button;
            }
          },
          error: (xhr, status, error) => {
            r;
            console.error("Error:", error);
          },
        });

        toastElement.removeEventListener("click", toastEventListenerOnClick);
      }
    };

    toastElement.addEventListener("click", toastEventListenerOnClick);
  };

  // Handle removal event on DOM for any removed Toast Component.
  const handleToastRemoved = (toastElement, data) => {
    let cookieKey = `FABToast-${data.ID}`;
    let cookie = FABCookie.getCookie(cookieKey);
    let expiration = parseInt(data.trigger.cookie.expiration);

    /**
     * The toast should be displayed if:
     * - expiration is not equal to 0 : no expiration
     * - cookie is not set : no cookie
     * - cookie is not equal to expiration : cookie expiration has changed
     */
    if (!cookie || (expiration != 0 && cookie && cookie != expiration)) {
      FABCookie.setCookie(cookieKey, expiration, expiration, "/");
    }
  };

  // Observe removal event on DOM for any Toast removed component.
  const observeToastRemoval = (toastElement, data) => {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        mutation.removedNodes.forEach((removedNode) => {
          if (removedNode === toastElement) {
            handleToastRemoved(removedNode, data);
          }
        });
      }
    });

    // Observe parent node for child removals
    const parent = toastElement.parentNode;
    if (parent) {
      observer.observe(parent, { childList: true });
    }
  };

  // Filter out the toasts components.
  to_display = to_display.filter((f) => ["toast", "scarcity_toast"].includes(f.type));

  // Trigger the creation of each Toasts components with delay if exists in plugin settings or default is zero (0).
  to_display.forEach((t, index) => {
    let delay = t.trigger.delay !== undefined ? t.trigger.delay.replace("ms", "") : 0;
    let cookieKey = `FABToast-${t.ID}`;
    let cookie = FABCookie.getCookie(cookieKey);
    let expiration = parseInt(t.trigger.cookie.expiration);

    /**
     * The toast should be displayed if:
     * - expiration is not equal to 0 : no expiration
     * - cookie is not set : no cookie
     * - cookie is not equal to expiration : cookie expiration has changed
     */
    if (expiration != 0 && cookie && cookie == expiration) {
      return;
    }

    setTimeout(() => {
      let toast = Toastify({
        node: createToastNode({ message: t.no_html_content, toast: t.toast }),
        duration: t.toast.duration,
        destination: t.toast.url_button,
        newWindow: t.toast.window === 1,
        close: t.toast.closeable === 1,
        gravity: t.toast.gravity,
        position: t.toast.position,
        style: {
          background: t.toast.background,
          color: t.toast.text_color,
        },
        stopOnFocus: false, // Override by custom listener.
      }).showToast();

      // Custom logic to pause and resume the toast.
      const toastElement = document.querySelector(".toastify");
      const toastBar = toastElement.querySelector(".toast-bar");
      if (toastElement && toastBar) {
        handleToastPauseResume(toastElement, toastBar, t.toast.duration);
        handleToastOnClick(toastElement, t);
        observeToastRemoval(toastElement, t);
      }

      // Custom toast close to backend color.
      const toastClose = toastElement.querySelector(".toast-close");
      if (toastClose) {
        toastClose.style.color = t.toast.text_color;
      }
    }, delay);
  });
</script>
